import { createGlobalStyle } from 'styled-components';
import { normalize } from 'styled-normalize';

import {
  blockquote,
  body,
  h1Styles,
  h2Styles,
  h3Styles,
  h4Styles,
  h5Styles,
  h6Styles,
  minBp,
} from './Mixins.styles';

import Perpetua from '../assets/fonts/Perpetua-Regular.ttf';
import ProximaNovaMedium from '../assets/fonts/ProximaNova-Medium.ttf';
import ProximaNova from '../assets/fonts/ProximaNova-Regular.ttf';
import ProximaNovaSemibold from '../assets/fonts/ProximaNova-Semibold.ttf';

import PoppinsBlack from '../assets/fonts/Rebrand-Fonts/Poppins/Poppins-Black.ttf';
import PoppinsBlackItalic from '../assets/fonts/Rebrand-Fonts/Poppins/Poppins-BlackItalic.ttf';
import PoppinsBold from '../assets/fonts/Rebrand-Fonts/Poppins/Poppins-Bold.ttf';
import PoppinsBoldItalic from '../assets/fonts/Rebrand-Fonts/Poppins/Poppins-BoldItalic.ttf';
import PoppinsExtraBold from '../assets/fonts/Rebrand-Fonts/Poppins/Poppins-ExtraBold.ttf';
import PoppinsExtraBoldItalic from '../assets/fonts/Rebrand-Fonts/Poppins/Poppins-ExtraBoldItalic.ttf';
import PoppinsExtraLight from '../assets/fonts/Rebrand-Fonts/Poppins/Poppins-ExtraLight.ttf';
import PoppinsExtraLightItalic from '../assets/fonts/Rebrand-Fonts/Poppins/Poppins-ExtraLightItalic.ttf';
import PoppinsItalic from '../assets/fonts/Rebrand-Fonts/Poppins/Poppins-Italic.ttf';
import PoppinsLight from '../assets/fonts/Rebrand-Fonts/Poppins/Poppins-Light.ttf';
import PoppinsLightItalic from '../assets/fonts/Rebrand-Fonts/Poppins/Poppins-LightItalic.ttf';
import PoppinsMedium from '../assets/fonts/Rebrand-Fonts/Poppins/Poppins-Medium.ttf';
import PoppinsMediumItalic from '../assets/fonts/Rebrand-Fonts/Poppins/Poppins-MediumItalic.ttf';
import PoppinsRegular from '../assets/fonts/Rebrand-Fonts/Poppins/Poppins-Regular.ttf';
import PoppinsSemiBold from '../assets/fonts/Rebrand-Fonts/Poppins/Poppins-SemiBold.ttf';
import PoppinsSemiBoldItalic from '../assets/fonts/Rebrand-Fonts/Poppins/Poppins-SemiBoldItalic.ttf';
import PoppinsThin from '../assets/fonts/Rebrand-Fonts/Poppins/Poppins-Thin.ttf';
import PoppinsThinItalic from '../assets/fonts/Rebrand-Fonts/Poppins/Poppins-ThinItalic.ttf';

import SouthCoastAlt from '../assets/fonts/Rebrand-Fonts/SouthCoast/south-coast-alt.ttf';
import SouthCoastSwash from '../assets/fonts/Rebrand-Fonts/SouthCoast/south-coast-swash.ttf';
import SouthCoastRegular from '../assets/fonts/Rebrand-Fonts/SouthCoast/south-coast.ttf';

import NoeDisplay from '../assets/fonts/Rebrand-Fonts/NoeDisplay/NoeDisplaySJP-Bold.otf';

import { getAssetDomain } from '../helpers/configHelpers';
import { getResponsiveTypography } from '../helpers/styleHelpers';

const assetDomain = getAssetDomain();

export const GlobalStyles = createGlobalStyle`
  @layer global {
    :root{
      --sjp-colours-brand-a: ${(props) => props.theme.colours.brand.a};
      --sjp-colours-brand-b: ${(props) => props.theme.colours.brand.b};
      --sjp-colours-text-primary: ${(props) => props.theme.colours.text.primary};
      --sjp-colours-text-secondary: ${(props) => props.theme.colours.text.secondary};
      --sjp-colours-text-tertiary: ${(props) => props.theme.colours.text.tertiary};
      --sjp-colours-text-reverse: ${(props) => props.theme.colours.text.reverse};
      /* stylelint-disable-next-line custom-property-pattern */
      --sjp-style-page-maxWidth: ${(props) => props.theme.style.page.maxWidth};
      --sjp-style-breakpoints-aa: ${(props) => props.theme.breakpoints.aa}px;
      --sjp-style-breakpoints-a: ${(props) => props.theme.breakpoints.a}px;
      --sjp-style-breakpoints-b: ${(props) => props.theme.breakpoints.b}px;
      --sjp-style-breakpoints-ba: ${(props) => props.theme.breakpoints.ba}px;
      --sjp-style-breakpoints-c: ${(props) => props.theme.breakpoints.c}px;
      --sjp-style-breakpoints-d: ${(props) => props.theme.breakpoints.d}px;
    }
    
  ${normalize}
  @font-face {
    font-family: 'Proxima Nova';
    src: url('${assetDomain + ProximaNova}') format('truetype');
    font-style: normal;
    font-weight: 400;
    font-display: swap;
  }

  @font-face {
    font-family: 'Proxima Nova';
    src: url('${assetDomain + ProximaNovaMedium}') format('truetype');
    font-style: normal;
    font-weight: 500;
    font-display: swap;
  }

  @font-face {
    font-family: 'Proxima Nova';
    src: url('${assetDomain + ProximaNovaSemibold}') format('truetype');
    font-weight: bold;
    font-weight: 600;
    font-display: swap;
  }

  @font-face {
    font-family: Perpetua;
    src: url('${assetDomain + Perpetua}') format('truetype');
    font-style: normal;
    font-weight: 400;
    font-display: swap;
  }

  @font-face {
    font-family: Poppins;
    src: url('${assetDomain + PoppinsBlack}') format('truetype');
    font-style: normal;
    font-weight: normal;
    font-display: swap;
  }

  @font-face {
    font-family: Poppins;
    src: url('${assetDomain + PoppinsBlackItalic}') format('truetype');
    font-style: italic;
    font-weight: normal;
    font-display: swap;
  }

  @font-face {
    font-family: Poppins;
    src: url('${assetDomain + PoppinsBold}') format('truetype');
    font-style: normal;
    font-weight: bold;
    font-display: swap;
  }

  @font-face {
    font-family: Poppins;
    src: url('${assetDomain + PoppinsBoldItalic}') format('truetype');
    font-style: italic;
    font-weight: bold;
    font-display: swap;
  }

  @font-face {
    font-family: Poppins;
    src: url('${assetDomain + PoppinsExtraBold}') format('truetype');
    font-style: normal;
    font-weight: 800;
    font-display: swap;
  }

  @font-face {
    font-family: Poppins;
    src: url('${assetDomain + PoppinsExtraBoldItalic}') format('truetype');
    font-style: italic;
    font-weight: 800;
    font-display: swap;
  }

  @font-face {
    font-family: Poppins;
    src: url('${assetDomain + PoppinsExtraLight}') format('truetype');
    font-style: normal;
    font-weight: 200;
    font-display: swap;
  }

  @font-face {
    font-family: Poppins;
    src: url('${assetDomain + PoppinsExtraLightItalic}') format('truetype');
    font-style: italic;
    font-weight: 200;
    font-display: swap;
  }

  @font-face {
    font-family: Poppins;
    src: url('${assetDomain + PoppinsItalic}') format('truetype');
    font-style: italic;
    font-weight: normal;
    font-display: swap;
  }

  @font-face {
    font-family: Poppins;
    src: url('${assetDomain + PoppinsLight}') format('truetype');
    font-style: normal;
    font-weight: 300;
    font-display: swap;
  }

  @font-face {
    font-family: Poppins;
    src: url('${assetDomain + PoppinsLightItalic}') format('truetype');
    font-style: italic;
    font-weight: 300;
    font-display: swap;
  }

  @font-face {
    font-family: Poppins;
    src: url('${assetDomain + PoppinsMedium}') format('truetype');
    font-style: normal;
    font-weight: 500;
    font-display: swap;
  }

  @font-face {
    font-family: Poppins;
    src: url('${assetDomain + PoppinsMediumItalic}') format('truetype');
    font-style: italic;
    font-weight: 500;
    font-display: swap;
  }

  @font-face {
    font-family: Poppins;
    src: url('${assetDomain + PoppinsRegular}') format('truetype');
    font-style: normal;
    font-weight: normal;
    font-display: swap;
  }

  @font-face {
    font-family: Poppins;
    src: url('${assetDomain + PoppinsSemiBold}') format('truetype');
    font-style: normal;
    font-weight: 600;
    font-display: swap;
  }

  @font-face {
    font-family: Poppins;
    src: url('${assetDomain + PoppinsSemiBoldItalic}') format('truetype');
    font-style: italic;
    font-weight: 600;
    font-display: swap;
  }

  @font-face {
    font-family: Poppins;
    src: url('${assetDomain + PoppinsThin}') format('truetype');
    font-style: normal;
    font-weight: 100;
    font-display: swap;
  }

  @font-face {
    font-family: Poppins;
    src: url('${assetDomain + PoppinsThinItalic}') format('truetype');
    font-style: italic;
    font-weight: 100;
    font-display: swap;
  }

  @font-face {
    font-family: 'South Coast';
    src: url('${assetDomain + SouthCoastRegular}') format('truetype');
    font-style: normal;
    font-weight: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'South Coast Alt';
    src: url('${assetDomain + SouthCoastAlt}') format('truetype');
    font-style: normal;
    font-weight: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'South Coast Swash';
    src: url('${assetDomain + SouthCoastSwash}') format('truetype');
    font-style: normal;
    font-weight: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'Noe Display';
    src: url('${assetDomain + NoeDisplay}') format('opentype');
    font-style: normal;
    font-weight: bold;
    font-display: swap;
  }

    html {
      box-sizing: border-box;
      -webkit-font-smoothing: antialiased;
      height: 100%;
    }

    *, *::before, *::after {
      box-sizing: inherit;
    }

    a > span {
      pointer-events: none;
    }



    body {
      display: flex;
      flex-direction: column;
      ${body}
      ${({ theme }) => `
        padding: 0;
        margin: 0;
        font-style: normal;
        color: ${theme.colours.text.primary};
        height: 100%;
        background: ${theme.colours.background.a};
      `}
    }
    
    #root {
      flex-grow: 1;
    }
    
    .Page {
      height: 100%;
    }

    .sjp-injectedArcConsentFooter {
      display: none;
      background-color: var(--sjp-colours-brand-b);
    }

    .sjp-injectedArcConsentFooter-content{
      padding: 0 5% 16px;
      /* stylelint-disable-next-line custom-property-pattern */
      max-width: var(--sjp-style-page-maxWidth);
      margin: 0 auto;
    }
    
    .sjp-injectedArcConsentFooter a {
      color: var(--sjp-colours-brand-a)!important;
      text-decoration: none;
      font-size: calc(${(props) =>
        getResponsiveTypography(
          props.theme,
          'fontSize',
          'body',
          props.theme.breakpoints.aa,
        )} - 2px);
      line-height: calc(${(props) =>
        getResponsiveTypography(
          props.theme,
          'lineHeight',
          'body',
          props.theme.breakpoints.aa,
        )} -2px);
    }
    
    img {
      max-width: 100%;
    }

    h1, h2, h3, h4, h5, h6 {
      ${({ theme }) => `
        color: ${theme.colours.text.heading};
        margin-top: 0px;
        margin-bottom: 15px;
        font-style: normal;
      `}
    }

    h1 {
      ${h1Styles}
    }

    h2 {
      ${h2Styles}
    }

    h3 {
      ${h3Styles}
    }

    h4 {
      ${h4Styles}
    }

    h5 {
      ${h5Styles}
    }

    h6 {
      ${h6Styles}
    }

    p {
      margin-top: 0;
      margin-bottom: 15px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    p + h1,
    p + h2,
    p + h3,
    p + h4,
    p + h5,
    p + h6,
    ul + h1,
    ul + h2,
    ul + h3,
    ul + h4,
    ul + h5,
    ul + h6,
    ol + h1,
    ol + h2,
    ol + h3,
    ol + h4,
    ol + h5,
    ol + h6 {
      ${({ theme }) => `
        margin-top: ${theme.spacing.inner};
      `}
    }

    a {
      ${({ theme }) => `
        color: ${theme.colours.link.default};
        text-decoration: underline;
        cursor: pointer;
        margin-top: 0px;
        margin-bottom: 15px;
        font-size: inherit;
        line-height: inherit;

        &:hover {
          color: ${theme.colours.link.rollover};
        }
      `}
    }

    ul, ol {
      padding: 0;
      margin-top: 0;
      margin-bottom: 10px;
      list-style-position: inside;
    }

    ul {
      list-style-type: disc;
    }

    li {
      padding: 0;
      margin-top: 0;
      margin-bottom: 5px;
    }

    input, textarea, select {
      ${({ theme, isError }) => `
        padding: 10px;
        font-size: ${getResponsiveTypography(theme, 'fontSize', 'body', theme.breakpoints.aa)};
        line-height: ${getResponsiveTypography(theme, 'lineHeight', 'body', theme.breakpoints.aa)};
        color: ${theme.colours.text.secondary};
        background-color: ${theme.colours.background.a};
        font-family: ${getResponsiveTypography(theme, 'fontFace', 'functional', theme.breakpoints.aa)}, Arial, sans-serif;
        border-radius: ${theme.style.radius.button};
        border: 1px solid ${isError ? theme.colours.status.r : theme.colours.text.secondary};
        height: 44px;
        width: 100%;
        margin-bottom: 0;
        margin-top: 0;
        -ms-flex: 1 1 auto; 
        height: 44px;
        
        &:focus { 
          color: ${theme.colours.text.primary};
          border-color: ${isError ? theme.colours.status.r : theme.colours.link.default};
        }

        ${minBp(theme.breakpoints.a)} {
          font-size: ${getResponsiveTypography(theme, 'fontSize', 'body', theme.breakpoints.a)};
          line-height: ${getResponsiveTypography(theme, 'lineHeight', 'body', theme.breakpoints.a)};
          font-family: ${getResponsiveTypography(
            theme,
            'fontFace',
            'functional',
            theme.breakpoints.a,
          )}, Arial, sans-serif;
        }

        ${minBp(theme.breakpoints.ba)} {
          font-size: ${getResponsiveTypography(theme, 'fontSize', 'body', theme.breakpoints.ba)};
          line-height: ${getResponsiveTypography(theme, 'lineHeight', 'body', theme.breakpoints.ba)};
          font-family: ${getResponsiveTypography(
            theme,
            'fontFace',
            'functional',
            theme.breakpoints.ba,
          )}, Arial, sans-serif;
        }
      `}
      
    }

    select {
      ${({ theme }) => `
      -webkit-appearance: none;
      background: ${theme.colours.background.a} url(data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0Ljk1IDEwIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZmZjt9LmNscy0ye2ZpbGw6IzQ0NDt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPmFycm93czwvdGl0bGU+PHJlY3QgY2xhc3M9ImNscy0xIiB3aWR0aD0iNC45NSIgaGVpZ2h0PSIxMCIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMiIgcG9pbnRzPSIxLjQxIDQuNjcgMi40OCAzLjE4IDMuNTQgNC42NyAxLjQxIDQuNjciLz48cG9seWdvbiBjbGFzcz0iY2xzLTIiIHBvaW50cz0iMy41NCA1LjMzIDIuNDggNi44MiAxLjQxIDUuMzMgMy41NCA1LjMzIi8+PC9zdmc+) no-repeat 100% 50%;
    `}
    }

    textarea {
        resize: vertical;
        min-height: 44px;
      }

    label {
      padding-bottom: 15px;
      display: block;
    }

    form {
      width: 100%;
    }

    iframe {
      border-width: 0;
    }

    svg {
      .background {
        ${({ theme }) => `
          fill: ${theme.colours.background.a};
        `}
      }
    }

    blockquote {
      ${blockquote}
      ${({ theme }) => `
        color: ${theme.colours.text.primary};
        margin-top: 0;
        margin-bottom: 15px;
      `};
    }

    #buorg {
      ${({ theme }) => `
        border: none;
        color: white;
        background-color: ${theme.colours.text.primary}
        animation: 1s ease-out 0s buorgfly
        font-size: 1rem;
        .buorg-pad {
          color: black;
          padding: 20px;
          display: flex;
          max-width: 960px;
          margin: 0 auto;
          text-align: left;
          justify-content: space-between;
          align-items: center;
          flex-direction: column;
          font-family: Proxima Nova;
          font-size: 16px;
          line-height: 24px;
          font-weight: 400;
          font-style: normal;

          ${minBp(theme.breakpoints.a)} {
            flex-direction: row;
          }
        }
        #buorgul {
          display: none;
        }
        #buorgig {
          background-color: white;
          color: black;
          text-transform: uppercase;
          padding: 5px 20px;
        }
        .buorg-icon{
          display: none;
        }
      `}
    }

    @keyframes buorgfly {
          from {
              transform: translateY(-50px)
          }

          to {
              transform: translateY(0)
          }
      }

    body:not(.user-is-tabbing) button:focus,
    body:not(.user-is-tabbing) div:focus,
    body:not(.user-is-tabbing) input:focus,
    body:not(.user-is-tabbing) select:focus,
    body:not(.user-is-tabbing) textarea:focus,
    body:not(.user-is-tabbing) svg:focus,
    body:not(.user-is-tabbing) a:focus {
      outline: none;
    }
  }
`;
